const addressNzLookupIntialStates = {
  addressSearch: {
    fetchingAddresses: {},
    addresses: {},
  },
};

export default addressNzLookupIntialStates;
